import { ThemeConfig } from 'components';
import 'assets/styles/index.scss';

export const Theme: ThemeConfig = {
  token: {
    colorPrimary: '#05796B',
    colorText: '#222530',
    // todo default focused hover color themes
  },
  components: {
    Tabs: {
      horizontalItemPadding: '0 0 6px 0',
      /* here is your component tokens */
    },
    Notification: {
      zIndexPopup: 9999999,
    },
    Menu: {
      itemPaddingInline: 12,
    },
    Table: {
      headerBg: '#F0F3F9',
      borderColor: '#E1E4EA',
      headerBorderRadius: 0,
    },
    Tag: {
      defaultBg: '#DDE8E6',
      defaultColor: '#05796B',
    },
    Select: {
      optionSelectedBg: '#dde8e6',
    },
    Button: {
      fontWeight: 500,
      fontSize: 16,
    },
    Form: {
      verticalLabelPadding: '0 0 4px',
    },
  },
};
